import store from "../../store/index";
import { connect } from "react-redux";

import SvgMapper from "./SvgMapper";

const mapStateToProps = state => {
  return { ssr: state.ssr };
};

export default connect(mapStateToProps)(SvgMapper);





// WEBPACK FOOTER //
// ./src/components/SvgMapper/index.js